import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';
//刷新保留store数据的插件
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState()]
});